export const walletBlockingReasons = {
  amlCft: ['4'],
  partner: ['3'],
  potentialFraud: ['5'],
  sanctionList: ['2', '6', '7', '8'],
  unknown: ['1']
};

export const lemonwayBlockingReasons = [
  { value: 2, title: 'matchingIndividual', detail: 'matchingDetail' },
  { value: 4, title: 'amlCft', detail: 'amlCftDetail' },
  { value: 5, title: 'fraudSuspicion', detail: 'fraudSuspicionDetail' },
  {
    value: 6,
    title: 'matchingLegalEntity',
    type: 'legalEntity',
    detail: 'matchingDetail'
  },
  {
    value: 7,
    title: 'matchingLegalEntity',
    type: 'legalRepresentative',
    detail: 'matchingDetail'
  },
  {
    value: 8,
    title: 'matchingLegalEntity',
    type: 'ubo',
    detail: 'matchingDetail'
  }
];
